/**
 * Uploads an image file using AJAX (XMLHttpRequest) and returns the live image URL.
 * @param file Image file to upload
 * @param uploadUrl The endpoint to upload the image to
 * @returns Promise<string> Resolves to the live image URL
 */

export function uploadImage(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const formData = new FormData();

        const xhr = new XMLHttpRequest();
        formData.append('photoimg', file);
        xhr.open('POST', 'https://broadcaster.appradiofm.com/user_profile_pic.php', true);
        xhr.responseType = 'text';
        xhr.timeout = 20000; // 20s timeout to avoid hanging uploads

        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) {
                try {
                    const response = JSON.parse(xhr.responseText);
                    // Adjust this according to your API's response structure
                    resolve(response.logo as string);
                } catch (e) {
                    console.log(e)
                    reject('Invalid JSON response');
                }
            } else {
                reject(`Upload failed with status ${xhr.status}`);
            }
        };

        xhr.onerror = function () {
            reject('Network error');
        };

        xhr.ontimeout = function () {
            reject('Upload timed out');
        };

        xhr.send(formData);
    });
}